<template>
  <div>
    <ClickerCube :visible="!showApp" @clicker="showApp = !showApp"></ClickerCube>
    <ClickerCube :colorHover="'#bababa'" :visible="showApp" @clicker="showApp = !showApp"></ClickerCube>

    <!-- <div v-show="showApp" class="block px-3 py-2 m-1 border bg-white border-gray-400 rounded-lg text-left">
      <div>
        <div class="inline-block cursor-default">
          Welcome to GamePlayApp
        </div>
        <div v-if="showApp" @click="showApp = !showApp" class="inline-block bg-white px-5 border border-gray-500 py-2 m-1 rounded-full text-center cursor-pointer">
          Close
        </div>
      </div>
    </div> -->

  </div>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
// import { BoxBufferGeometry, MeshBasicMaterial, Mesh } from 'three'

export default {
  mixins: [O3DG2],
  methods: {
  },
  data () {
    return {
      showApp: false
    }
  },
  mounted () {
    // this.o3d.scale.set(1 / 0.015, 1 / 0.015, 1 / 0.015)
  }
}
</script>

<style>

</style>